import { useMemo, useState, useEffect } from "react";
import { useLocation, Link, useParams } from "react-router-dom";
import DataTable from "react-data-table-component";
import { createColumns } from "../../helpers";
import { DATATABLE_CUSTOM_STYLES } from "../../constants/datatableStyles";
import CustomPagination from "../../Components/CustomPagination";
import PageTitle from "../../Components/UI/PageTitle";
import RowLoader from "../../Components/UI/RowLoader";
import EyeDetailsIcon from "../../Components/Svgs/EyeDetailsIcon";
import { getPartnerSettlementHistory } from "../../apis";
import ErrorAnimationComponent from "../../assets/lottie/ErrorAnimation/ErrorAnimationComponent";

const PartnerSettlementHistory = () => {
  const { partnerId } = useParams();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState();
  const [paginator, setPaginator] = useState(true);
  const [data, setData] = useState([]);
  const [totalsData, setTotalsData] = useState([]);
  const [currentPage, setCurrentPage] = useState(
    parseInt(new URLSearchParams(location.search).get("page"), 10) || 1
  );

  console.log(data);
  console.log(totalsData);

  useEffect(() => {
    setIsLoading(true);
    getPartnerSettlementHistory(partnerId, currentPage)
      .then((response) => {
        setData(response.data.data.settlements.data);
        setTotalsData(response.data.data.totals);
        setPaginator({
          current_page: response.data.data.settlements.current_page,
          last_page: response.data.data.settlements.last_page,
        });
      })
      .catch((error) => {
        console.log(error);
        setError(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [partnerId, currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const hiddenColumns = ["partner_name", "settlement_id"]; // Add column keys you want to hide

  const customColumns = [
    {
      name: "Details",
      selector: (row) => row.name + " - custom",
      ui: (row) => (
        <div className="tw-flex tw-gap-1">
          <Link
            className="tw-text-primary"
            to={`/settlement/${row.settlement_id}/settled-partners/${partnerId}`}
          >
            <EyeDetailsIcon className="tw-w-8" />
          </Link>
        </div>
      ),
    },
  ];

  // const columns = useMemo(() => {
  //   return createColumns(data, customColumns, hiddenColumns, true).map(
  //     (col) => ({
  //       ...col,
  //       // sortable: col.name === "Name" || col.name === "Joined Date",
  //       sortable: false,
  //       width: "100px",
  //     })
  //   );
  // }, [[]]);

  if (error) return <ErrorAnimationComponent message={error} />;

  return (
    <>
      {data?.[0]?.partner_name && (
        <PageTitle
          title={`Settlement History For ${data?.[0]?.partner_name}`}
        />
      )}

      <div className="bg-white flex flex-col mt-4">
        <div className="bg-white shadow-lg rounded-lg flex flex-col p-2 gap-2 mb-5">
          <div className="tw-overflow-x-auto">
            <table className="tw-min-w-full tw-text-center tw-bg-white tw-rounded-lg tw-shadow-md">
              <thead>
                <tr className="tw-bg-[rgba(107,114,128,0.2)] tw-text-left tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider tw-whitespace-nowrap">
                  <th className="tw-px-4 tw-py-4">Num</th>
                  <th className="tw-px-4 tw-py-4">Settlement Date</th>
                  <th className="tw-px-4 tw-py-4">Settlement Num</th>
                  <th className="tw-px-4 tw-py-4">Total Direct E.M</th>
                  <th className="tw-px-4 tw-py-4">Total E.M</th>
                  <th className="tw-px-4 tw-py-4">Total Points</th>
                  <th className="tw-px-4 tw-py-4">Total PV E.M</th>
                  <th className="tw-px-4 tw-py-4">Total PVL</th>
                  <th className="tw-px-4 tw-py-4">Total PVL</th>
                  <th className="tw-px-4 tw-py-4">Details</th>
                </tr>
              </thead>
              <tbody>
                {data?.map((d, index) => (
                  <tr key={index} className="tw-border-b tw-border-gray-200">
                    <td className="tw-px-4 tw-py-2 tw-whitespace-nowrap tw-text-sm tw-font-medium tw-text-gray-900">
                      {d.num}
                    </td>
                    <td className="tw-px-4 tw-py-2 tw-whitespace-nowrap tw-text-sm tw-text-gray-500">
                      {d.settlement_date}
                    </td>
                    <td className="tw-px-4 tw-py-2 tw-whitespace-nowrap tw-text-sm tw-text-gray-500">
                      {d.settlement_num}
                    </td>
                    <td className="tw-px-4 tw-py-2 tw-whitespace-nowrap tw-text-sm tw-text-gray-500">
                      {d.total_direct_em}
                    </td>
                    <td className="tw-px-4 tw-py-2 tw-whitespace-nowrap tw-text-sm tw-text-gray-500">
                      {d.total_em}
                    </td>
                    <td className="tw-px-4 tw-py-2 tw-whitespace-nowrap tw-text-sm tw-text-gray-500">
                      {d.total_points}
                    </td>
                    <td className="tw-px-4 tw-py-2 tw-whitespace-nowrap tw-text-sm tw-text-gray-500">
                      {d.total_pv_em}
                    </td>
                    <td className="tw-px-4 tw-py-2 tw-whitespace-nowrap tw-text-sm tw-text-gray-500">
                      {d.total_pvl}
                    </td>
                    <td className="tw-px-4 tw-py-2 tw-whitespace-nowrap tw-text-sm tw-text-gray-500">
                      {d.total_pvr}
                    </td>
                    <td className="tw-px-4 tw-py-2 tw-whitespace-nowrap tw-text-sm tw-text-gray-500">
                      <div className="tw-flex tw-gap-1 tw-justify-center">
                        <Link
                          className="tw-text-primary"
                          to={`/settlement/${d.settlement_id}/settled-partners/${partnerId}`}
                        >
                          <EyeDetailsIcon className="tw-w-8" />
                        </Link>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr className="tw-border-t tw-bg-gray-50 tw-text-sm tw-font-semibold tw-text-center tw-text-gray-700">
                  <td className="tw-px-4 tw-py-2">Total</td>
                  <td className="tw-px-4 tw-py-2"></td>
                  <td className="tw-px-4 tw-py-2"></td>
                  <td className="tw-px-4 tw-py-2">
                    {totalsData.total_direct_em_sum ?? 0}
                  </td>
                  <td className="tw-px-4 tw-py-2">
                    {totalsData.total_em_sum ?? 0}
                  </td>
                  <td className="tw-px-4 tw-py-2">
                    {totalsData.total_points_sum ?? 0}
                  </td>
                  <td className="tw-px-4 tw-py-2">
                    {totalsData.total_pv_em_sum ?? 0}
                  </td>
                  <td className="tw-px-4 tw-py-2">
                    {totalsData.total_pvl_sum ?? 0}
                  </td>
                  <td className="tw-px-4 tw-py-2">
                    {totalsData.total_pvr_sum ?? 0}
                  </td>
                  <td className="tw-px-4 tw-py-2"></td>
                </tr>
              </tfoot>
            </table>
          </div>

          <div className="flex justify-center mt-2">
            <CustomPagination
              totalPages={paginator?.last_page}
              currentPage={paginator?.current_page || 1}
              onPageChange={handlePageChange}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default PartnerSettlementHistory;
